import model from "@/ts/model";
import { showNotification } from "../notifications-management";
import { closeAllModals } from "../modal-management";
import type { Component } from "vue";
import type { PromoCode } from "@/ts/types/realtime-bonus-engine-types";
import type { SiteNotificationOptions } from "@/ts/types/notification-types";

let notif: SiteNotificationOptions | undefined;

const comps: Partial<Record<PromoCode, () => Promise<Component>>> = {};

export default {
    startMiniGame(promoCode: string){
        const component = comps[promoCode as PromoCode];
        if(!component) return;

        notif = showNotification({
            component,
            noBtns: true,
            customClass: 'optimove',
            overlayCloseDisabled: true,
        });

        closeAllModals();
    },
    init(){
        model.on('LogoutComplete', () => {
            notif?.closeMessage?.();
            notif = undefined;
        });
    },
}